import { render, staticRenderFns } from "./navFooter.vue?vue&type=template&id=40ef4e4c&scoped=true&"
import script from "./navFooter.vue?vue&type=script&lang=js&"
export * from "./navFooter.vue?vue&type=script&lang=js&"
import style0 from "./navFooter.vue?vue&type=style&index=0&id=40ef4e4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ef4e4c",
  null
  
)

export default component.exports